import React from "react";

const Loader = () => {
  return (
    <svg
      xmlnssvg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlnxlink="http://www.w3.org/1999/xlink"
      version="1.0"
      width="16px"
      height="16px"
      viewBox="0 0 128 128"
      xmlSpace="preserve"
    >
      <g>
        <circle cx="16" cy="64" r="16" fill="#4417a6" />
        <circle
          cx="16"
          cy="64"
          r="16"
          fill="#8264c4"
          transform="rotate(45,64,64)"
        />
        <circle
          cx="16"
          cy="64"
          r="16"
          fill="#b19eda"
          transform="rotate(90,64,64)"
        />
        <circle
          cx="16"
          cy="64"
          r="16"
          fill="#dad1ed"
          transform="rotate(135,64,64)"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
          calcMode="discrete"
          dur="1280ms"
          repeatCount="indefinite"
        ></animateTransform>
      </g>
    </svg>
  );
};

export default Loader;
